import { Link } from "react-router-dom";
import "../Services.css";
import { useState } from "react";

const FAQSection = () => {
  const faqs = [
    {
      question: "1. Can a Non-US Resident or Non-US Citizen Incorporate a Business in the USA?",
      answer: (
        <>
          <p>Yes. Non-US residents can form a company in the U.S. You don't need to be a U.S. citizen or have a U.S. address. You'll need a Registered Agent and an EIN (Employer Identification Number) for taxes and banking.</p>
        </>
      )
    },
    {
      question: "2. What Business Structures Can I Choose From?",
      answer: (
        <>
          <p>The two most common structures are LLC (Limited Liability Company) and C-Corporation (C-Corp). LLCs suit small businesses seeking flexibility, while C-Corps are ideal for startups aiming for external investment.</p>
        </>
      )
    },
    {
      question: "3. What is a Registered Agent, and Do I Need One?",
      answer: (
        <>
          <p>A Registered Agent is a mandatory contact for official legal and tax documents. All U.S. LLCs and Corporations must have one in their formation state. BooksComply offers this in all 50 states.</p>
        </>
      )
    },    
    {
      question: "4. What is an EIN and Why Do I Need It?",
      answer: (
        <>
          <p>An EIN (Employer Identification Number) is a tax ID issued by the IRS. You need it to open a bank account, file taxes, and hire employees.</p>
        </>
      )
    }
  ];

  const [openIdx, setOpenIdx] = useState(null);
  const toggle = (idx) => setOpenIdx((prev) => (prev === idx ? null : idx));

  return (
    <div className="usa-faq-section py-5">
      <div className="container">
        {/* FAQ Section Title */}
        <div className="usa-faq-header">
          <h2 className="usa-faq-title">USA Company Formation FAQs</h2>
          <p className="usa-faq-subtitle">Get answers to common questions about forming a company in the USA</p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="usa-faq-accordion">
              {faqs.map((faq, index) => {
                const isOpen = openIdx === index;
                const isString = typeof faq.answer === 'string';
                return (
                  <div className="usa-faq-item" key={index}>
                    <button
                      type="button"
                      className="usa-faq-toggle"
                      aria-expanded={isOpen}
                      aria-controls={`usa-faq-content-${index}`}
                      onClick={() => toggle(index)}
                    >
                      <h5 className="usa-faq-question">{faq.question}</h5>
                      <span className="usa-faq-icon" aria-hidden>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </span>
                    </button>
                    <div
                      id={`usa-faq-content-${index}`}
                      className={`usa-faq-answer-container ${isOpen ? 'is-open' : ''}`}
                      role="region"
                      aria-labelledby={`usa-faq-toggle-${index}`}
                    >
                      <div className="usa-faq-answer">
                        {isString ? (
                          <div className="usa-faq-answer-content" dangerouslySetInnerHTML={{ __html: faq.answer.replace(/\n/g, '<br />') }} />
                        ) : (
                          <div className="usa-faq-answer-content">{faq.answer}</div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;